export default "__VITE_ASSET__CZRG8nIg__"